import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ProcessMapPage } from '@/pages/processes/process-map/ProcessMapPage';
import { createCaslGuard } from '@/lib/auth/permissionGuards';

const processMapSearchSchema = z.object({
  focusProcessId: z.string().optional()
});

export const Route = createFileRoute('/$slug/processes/process-map')({
  beforeLoad: createCaslGuard('ProcessMap'),
  component: ProcessMapPage,
  validateSearch: processMapSearchSchema
});
